

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Loading from 'components_newui/Loading';

const ProtectedRoute = ({
  component: Component,
  allowed,
  isLoading,
  redirectPath = '/',
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      const { pathname } = props.location;

      // TEMP TRACE (route authorization timing) - remove once verified
      if (isLoading) {
        console.log('[route-auth] 3. roles not ready, holding with loader ->', pathname);
        return <Loading />;
      }
      console.log('[route-auth] 6. roles ready, deciding ->', pathname, {
        allowed: !!allowed,
        goingTo: allowed ? 'component' : redirectPath,
      });

      return allowed ? (
        <Component {...props} />
      ) : (
        <Redirect to={redirectPath} />
      );
    }}
  />
);
export default ProtectedRoute;